import { render } from "./default-iframe.html?vue&type=template&id=05df3c4e&scoped=true&ts=true"
import script from "./default-iframe.vue?vue&type=script&lang=ts"
export * from "./default-iframe.vue?vue&type=script&lang=ts"

import "./default-iframe.scss?vue&type=style&index=0&id=05df3c4e&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05df3c4e"]])

export default __exports__